import { render, staticRenderFns } from "./estadisticas_pormesComponent.vue?vue&type=template&id=2b583a48&"
import script from "./estadisticas_pormesComponent.vue?vue&type=script&lang=js&"
export * from "./estadisticas_pormesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports